module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Leave_Tomorrow_Behind2#Contents-A"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Much thanks goes to:")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Lydia and Sharon Hartzler for sharing their knowledge about cows and 4-H, answering my questions practically before I asked them, and giving me great ideas. I’m glad my questions about manure could offer family suppertime conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("KB Inglee and Elizabeth “Bodge” Inglee-Richards, and Ron Baldridge, DVM, for their veterinary expertise and willingness to answer strange questions about medicines and animal health.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Cindy Luginbill, for answering questions about salons and day spas.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Lee Diller, for being a great boss at my “other” job.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Nancy Clemens for being an awesome and speedy first reader, and always encouraging my dream.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Steve, Tristan, and Sophia Smucker for being wholly supportive and enthusiastic about my writing life, and for being the best family I could ask for.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("My wonderful, wonderful readers, who asked many times when Stella would be coming back to visit. I’m so glad you insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The team at Poisoned Pen Press for their camaraderie, flexibility, and way of making this job so fun.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("If I changed information about 4-H, or veterinary meds, or beauty salons, or the recording industry, it was purely because of literary license. The people I named all know their stuff.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d551c266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Leave_Tomorrow_Behind-4.vue
// module id = 72
// module chunks = 0